import { DividerProps } from './Divider.type'
import { StyledDivider } from './styles'

const Divider = ({
  orientation = 'horizontal',
  color = 'lightGray',
  heightClass = 'extraSmall',
  spacingClass = 'regular',
  ...htmlProps
}: DividerProps) => {
  return (
    <StyledDivider
      $orientation={orientation}
      $color={color}
      spacingClass={spacingClass}
      heightClass={heightClass}
      {...htmlProps}
    />
  )
}

export default Divider
